export default __webpack_public_path__ + "static/MD_SearchThumb_Cloud_Sets-e9e0dc81848eac21ea63a9cadd64fdc3.webp";